

import { NgModule, LOCALE_ID } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';

import { RouterModule, Routes } from '@angular/router';
import {MatRadioModule} from '@angular/material/radio'
import { MatBottomSheetModule, MatButtonModule, MatIconModule } from '@angular/material';
import {MatButtonToggleModule} from '@angular/material/button-toggle'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FiltroSheetComponent } from './filtro-sheet.component';
const routes: Routes = [
    //{ path: '', component:BookComponent},
  ];


@NgModule({
    declarations: [FiltroSheetComponent],
    exports: [FiltroSheetComponent],
    imports: [ SharedModule,MatBottomSheetModule,MatButtonToggleModule, MatButtonModule, RouterModule.forChild(routes),NgxSkeletonLoaderModule,MatRadioModule,MatIconModule],
    providers: [{ provide: LOCALE_ID, useValue: "pt" }],
    entryComponents:[FiltroSheetComponent]
})
export class FiltroSheetModule { }
